import Vue from 'vue';
import VueRouter from 'vue-router';
import sensorsdata from 'sa-sdk-javascript';
import store from './store/store';
import UserService from './libs/user';
import Order from './libs/order';
import { env } from './libs/env';
import './libs/mta';
import browserService from './services/browser-service';

import Login from './pages/Login';
import Forget from './pages/Forget';
import Join from './pages/Join';
import Bind from './pages/Bind';
import Message from './pages/Message';
import Index from './pages/index/Index';
import Countries from './pages/countries/Countries';
import Country from './pages/country/Country';
import CountryVisaStrategy from './pages/country/country-visa-strategy/country-visa-strategy.vue';


import Product from './pages/product/Product';
import questionDetail from './pages/product/questionDetail';
import Orders from './pages/Orders';
import FillApplication from './pages/application/FillApplication';
import OrderDetail from './pages/OrderDetail';
import OrderDiffPay from './pages/OrderDiffPay';
import OrderMailList from './pages/OrderMailList';
import InterviewNotification from './pages/InterviewNotification';
import ShunFengPickUp from './pages/ShunFengPickUp';
import InterviewChange from './pages/InterviewChange';
import MyCoupon from './pages/user/user-children/MyCoupon';
import about from './pages/about';
import InterviewChangePaySuc from './pages/InterViewChangePaySuc';
import orderEvaluation from './pages/orders/order-evaluation/orderEvaluation';
import Guide from './pages/guide/Guide';
import VisaKnowledge from './pages/academy/VisaKnowledge';
import LatestNews from './pages/academy/LatestNews';
import VisaOpenClass from './pages/academy/VisaOpenClass';
import VisaGuide from './pages/academy/VisaGuide';
import CaseAnalysis from './pages/academy/CaseAnalysis';
import AccountApplication from './pages/guide/sub/AccountApplication';
import BindWeChat from './pages/guide/sub/BindWeChat';
import AccountRecharge from './pages/guide/sub/AccountRecharge';
import childrenAccount from './pages/guide/sub/childrenAccount';
import ForwardGoods from './pages/guide/sub/ForwardGoods';
import UploadData from './pages/guide/sub/UploadData';
import PayOrder from './pages/guide/sub/PayOrder';
import AboutOrder from './pages/guide/sub/AboutOrder';
import WxaUsage from './pages/guide/newUser/WxaUsage';
import eNtriUsage from './pages/guide/newUser/eNtriUsage';
import interviewProduct from './pages/guide/sub/interviewProduct';
import eNTRI from './pages/guide/sub/eNTRI';
import offlineOrder from './pages/guide/sub/offlineOrder';
import mailMaterial from './pages/guide/sub/mailMaterial';
import article from './pages/article/article';
import VideoDetail from './pages/academy/VideoDetail';
import User from './pages/user/User';
import EquityCenter from './pages/user/user-children/equity-center/equity-center';
import Balance from './pages/user/user-children/Balance';
import PublicAudit from './pages/user/user-children/PublicAudit';
import Staff from './pages/user/user-children/Staff';
import SignOut from './pages/user/user-children/sign-out';
import Address from './pages/user/user-children/Address';
import Profile from './pages/user/user-children/Profile';
import Shop from './pages/user/user-children/Shop';
import HistoryApplicant from './pages/user/user-children/history-applicant/history-applicant';
import EmbassyHoliday from './pages/EmbassyHoliday';
import Reupload from './pages/Reupload';
import Upload from './pages/Upload';
import CityAgent from './pages/CityAgent';
import AdminOrder from './pages/AdminOrder';
import Academy from './pages/academy/Academy';
import ClassDetail from './pages/academy/ClassDetail';
import RejectProductApplicant from './pages/orders/reject-product-applicant/reject-product-applicant';
import PageCheck from './pages/orders/page-check/page-check';


// 上上签保险
import Insurances from './pages/Insurances';
import InsuranceDetail from './pages/insurance/InsuranceDetail';
import InsuranceInfo from './pages/insurance/insuranceOrder/insuranceInfo/InsuranceInfo';
import InsurancePay from './pages/insurance/insuranceOrder/InsurancePay';
import InsuranceSuccess from './pages/insurance/insuranceOrder/InsuranceSuccess';

import WaittingForUpload from './pages/ordering/WaittingForUpload';
import WaittingForChooseInterviewTime from './pages/ordering/WaittingForChooseInterviewTime';
import OrderComfirm from './pages/ordering/OrderComfirm';

import activity from './pages/activity/activity';

import BusinessView from './pages/businessInsurance/insurancePage/insuranceView';

// 金棕榈支付完成界面
import PayConfirm from './components/pay-confirm';

import fliggyOrderDetail from './pages/orders/fliggy-order-detail/fliggyOrderDetail';
import RechargeActivity from './pages/activity/RechargeActivity';

import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/privicy/PrivacyPolicy';

import ISOAuth from './pages/ISOAuth';

import invoiceManage from './pages/invoice-manage/InvoiceManage';
import payInvoice from './pages/invoice-manage/PayInvoice';
import payInvoiceSuccess from './pages/invoice-manage/PayInvoiceSuccess';

import OnJobList from './pages/on-job/OnJobList';
import EditOnJob from './pages/on-job/EditOnJob';


import FestivalActivity from './pages/activity/festival';
import DailyActivity from './pages/activity/daily-activity';

import VisaApi from './pages/VisaApi';

import ChatVisa from './pages/chat-visa/ChatVisa.vue';
import ConfirmPostMessage from './pages/insurance/insuranceOrder/confirm-post-message.vue';

// 修改商品
import OrderEditProduct from './pages/ordering/components/order-edit-product.vue';


Vue.use(VueRouter);

export const routes = [{
  path: '/login',
  name: 'login',
  component: Login,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/forget',
  name: 'forget',
  component: Forget,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/join',
  name: 'join',
  component: Join,
},
{
  path: '/bind',
  name: 'bind',
  component: Bind,
  meta: {
    needLogin: true,
  },
},
{
  path: '/message',
  name: 'message',
  component: Message,
  meta: {
    needLogin: true,
  },
},
{
  path: '/confirm-post-message',
  name: 'confirmPostMessage',
  component: ConfirmPostMessage,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/',
  name: 'index',
  component: Index,
  meta: {
    keepAlive: true,
  },
},
{
  path: '/countries',
  name: 'countries',
  component: Countries,
},
// 国家页和商品页都跳转到新的商品详情页去，方便兼容旧跳转逻辑
{
  path: '/countries/country/:id',
  name: 'country',
  component: Country,
},
{
  path: '/countries/country/:id/strategy',
  name: 'CountryVisaStrategy',
  component: CountryVisaStrategy,
},
{
  path: '/countries/product/:visa_product_id',
  name: 'product',
  redirect: (to) => {
    const query = to.query || {};
    query.visa_product_id = to.params.visa_product_id;
    return {
      name: 'productDetail',
      query,
    };
  },
},

{
  path: '/countries/product-detail',
  name: 'productDetail',
  component: Product,
},

{
  path: '/academy',
  name: 'academy',
  component: Academy,
},
{
  path: '/class-detail/:courseId',
  name: 'classDetail',
  component: ClassDetail,
},
{
  path: '/countries/question/:id',
  name: 'questionDetail',
  component: questionDetail,
},
{
  path: '/orders',
  name: 'orders',
  component: Orders,
  meta: {
    needLogin: true,
  },
},
{
  path: '/admin-order',
  name: 'adminOrder',
  component: AdminOrder,
  meta: {
    needLogin: true,
  },
},

{
  path: '/orders/ordering/waitting-for-upload/:oid',
  name: 'waittingForUpload',
  component: WaittingForUpload,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/ordering/waitting-for-choose-interview-time/:oid',
  name: 'waittingForChooseInterviewTime',
  component: WaittingForChooseInterviewTime,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/ordering/order-comfirm/:oid',
  name: 'orderComfirm',
  component: OrderComfirm,
  meta: {
    needLogin: true,
    hideFooter: true,
  },
},

{
  path: '/orders/ordering/pay-confirm/:oid',
  name: 'payConfirm',
  component: PayConfirm,
  meta: {
    needLogin: true,
  },
},

{
  path: '/orders/ordering/:oid/upload/:aid',
  name: 'upload',
  component: Upload,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/ordering/:oid/apply/:aid',
  name: 'apply',
  component: FillApplication,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid',
  name: 'orderDetail',
  component: OrderDetail,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/page-check',
  name: 'orderDetailPageCheck',
  component: PageCheck,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/fliggyDetail/:oid',
  name: 'fliggyOrderDetail',
  component: fliggyOrderDetail,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/diff-pay',
  name: 'orderDiffPay',
  component: OrderDiffPay,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/order-mail-list',
  name: 'orderMailList',
  component: OrderMailList,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/reupload/:aid/:back/',
  name: 'reupload',
  component: Reupload,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/interview/:aid',
  name: 'interview',
  component: InterviewNotification,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/:pid/sfpickup',
  name: 'sfpickup',
  component: ShunFengPickUp,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/interview-change',
  name: 'interviewChange',
  component: InterviewChange,
  meta: {
    needLogin: true,
  },
},
{
  path: '/orders/detail/:oid/re-order-pay',
  name: 'reOrderPay',
  component: InterviewChange,
  meta: {
    needLogin: true,
  },
},

{
  path: '/orders/detail/:oid/interview-change/pay-suc',
  name: 'interviewChangePaySuc',
  component: InterviewChangePaySuc,
  meta: {
    needLogin: true,
  },
},

{
  path: '/orders/detail/:oid/reject-product-applicant/:aid',
  name: 'rejectProductApplicant',
  component: RejectProductApplicant,
  meta: {
    needLogin: true,
  },
},

{
  path: '/orders/evaluation/:oid',
  name: 'orderEvaluation',
  component: orderEvaluation,
  meta: {
    needLogin: true,
  },
},

{
  path: '/about',
  name: 'about',
  component: about,
},
{
  path: '/about-us',
  name: 'aboutUs',
  component: AboutUs,
},

{
  path: '/guide',
  name: 'guide',
  component: Guide,
  redirect: '/guide/accountApplication',
  children: [{
    path: '',
    beforeEnter(to, from, next) {
      next('/guide/accountApplication');
    },
  },
  {
    path: 'accountApplication',
    name: 'accountApplication',
    component: AccountApplication,
  },
  {
    path: 'bindWeChat',
    name: 'bindWeChat',
    component: BindWeChat,
  },
  {
    path: 'accountRecharge',
    name: 'accountRecharge',
    component: AccountRecharge,
  },
  {
    path: 'childrenAccount',
    name: 'childrenAccount',
    component: childrenAccount,
  },
  {
    path: 'forwardGoods',
    name: 'forwardGoods',
    component: ForwardGoods,
  },
  {
    path: 'uploadData',
    name: 'uploadData',
    component: UploadData,
  },
  {
    path: 'payOrder',
    name: 'payOrder',
    component: PayOrder,
  },
  {
    path: 'aboutOrder',
    name: 'aboutOrder',
    component: AboutOrder,
  },
  // {
  //   path: 'otaOrder',
  //   name: 'OtaOrder',
  //   component: OtaOrder,
  // },
  {
    path: 'wxa-usage',
    name: 'wxaUsage',
    component: WxaUsage,
  },
  {
    path: 'eNtri-usage',
    name: 'eNtriUsage',
    component: eNtriUsage,
  },
  {
    path: 'interviewProduct',
    name: 'interviewProduct',
    component: interviewProduct,
  },
  {
    path: 'eNTRI',
    name: 'eNTRI',
    component: eNTRI,
  },
  {
    path: 'offlineOrder',
    name: 'offlineOrder',
    component: offlineOrder,
  },
  {
    path: 'mailMaterial',
    name: 'mailMaterial',
    component: mailMaterial,
  },
  ],
},
{
  path: '/visa-article/view/:id',
  name: 'article',
  component: article,
},
{
  path: '/visa-video/:id',
  name: 'videoDetail',
  component: VideoDetail,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/visa-knowledge',
  name: 'visaKnowledge',
  component: VisaKnowledge,
  children: [
    {
      path: 'latest-news',
      name: 'latestNews',
      component: LatestNews,
    },
    {
      path: 'visa-open-class',
      name: 'visaOpenClass',
      component: VisaOpenClass,
    },
    {
      path: 'visa-guide',
      name: 'visaGuide',
      component: VisaGuide,
    },
    {
      path: 'case-analysis',
      name: 'caseAnalysis',
      component: CaseAnalysis,
    },
  ],
},
{
  path: '/recharge-activity',
  name: 'RechargeActivity',
  component: RechargeActivity,
},
{
  path: '/user',
  name: 'user',
  component: User,
  meta: {
    needLogin: true,
  },
  children: [
    {
      path: 'equity',
      name: 'equity',
      component: EquityCenter,
    },
    {
      path: 'balance',
      name: 'balance',
      component: Balance,
      meta: {
        notBind: true,
      },
    },
    {
      path: 'audit',
      name: 'audit',
      component: PublicAudit,
      meta: {
        notBind: true,
      },
    },
    {
      path: 'staff',
      name: 'staff',
      meta: {
        needAdmin: true,
      },
      component: Staff,
    },
    {
      path: 'sign-out',
      name: 'signOut',
      component: SignOut,
    },
    {
      path: 'address',
      name: 'address',
      component: Address,
    },
    {
      path: 'profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: 'shop',
      name: 'shop',
      meta: {
        needAdmin: true,
      },
      component: Shop,
    },

    {
      path: 'coupon',
      name: 'coupon',
      component: MyCoupon,
    },
    {
      path: 'history_applicant',
      name: 'history_applicant',
      component: HistoryApplicant,
    },
  ],
},
{
  path: '/embassyHoliday',
  name: 'embassyHoliday',
  component: EmbassyHoliday,
},
{
  path: '/cityAgent',
  name: 'cityAgent',
  component: CityAgent,
},
{
  path: '/insurances',
  name: 'insurances',
  component: Insurances,
}, // 保险商品列表
{
  path: '/insuranceDetail/:id',
  name: 'insuranceDetail',
  component: InsuranceDetail,
}, // 保险商品详情
{
  path: '/insuranceInfo',
  name: 'insuranceInfo',
  meta: {
    needLogin: true,
  },
  component: InsuranceInfo,
}, // 保险下单
{
  path: '/insurancePay',
  name: 'insurancePay',
  meta: {
    needLogin: true,
  },
  component: InsurancePay,
}, // 保险支付
{
  path: '/insuranceSuccess',
  name: 'insuranceSuccess',
  meta: {
    needLogin: true,
  },
  component: InsuranceSuccess,
}, // 保险支付成功
{
  path: '/activity',
  name: 'activity',
  component: activity,
},
{
  path: '/BusinessView',
  name: 'BusinessView',
  component: BusinessView,
},
{
  path: '/privacy-policy/:to',
  name: 'PrivacyPolicy',
  component: PrivacyPolicy,
},
{
  path: '/iso-auth',
  name: 'ISOAuth',
  component: ISOAuth,
},
{
  path: '/invoice-manage',
  name: 'invoiceManage',
  component: invoiceManage,
},
{
  path: '/pay-invoice/:id',
  name: 'payInvoice',
  component: payInvoice,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/pay-invoice-success',
  name: 'payInvoiceSuccess',
  component: payInvoiceSuccess,
  meta: {
    hideFooter: true,
  },
},
{
  path: '/on-job-list',
  name: 'OnJobList',
  component: OnJobList,
  meta: {
    needLogin: true,
  },
},
{
  path: '/on-job-edit',
  name: 'EditOnJob',
  component: EditOnJob,
  meta: {
    needLogin: true,
  },
},
{
  path: '/activity/festival',
  name: 'FestivalActivity',
  component: FestivalActivity,
  meta: {
    needLogin: false,
  },
},
{
  path: '/visa-api',
  name: 'VisaApi',
  component: VisaApi,
  meta: {
    needLogin: false,
  },
},
{
  path: '/activity/daily-activity',
  name: 'DailyActivity',
  component: DailyActivity,
  meta: {
    needLogin: false,
  },
},
{
  path: '/chat-visa',
  name: 'ChatVisa',
  component: ChatVisa,
  meta: {
    needLogin: false,
    hideFooter: true,
  },
},
{
  path: '/orders/edit-product',
  name: 'EditProduct',
  component: OrderEditProduct,
  meta: {
    needLogin: true,
    hideFooter: true,
  },
},


];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

// 鉴权
router.beforeEach((to, from, next) => {
  setTimeout(() => {
    if (to.path !== from.path) {
      browserService.setHtmlSeo(to.meta.title ? {
        title: to.meta.title,
      } : undefined);
    }

    // 需要登录
    if (to.matched.some(path => path.meta.needLogin)) {
      if (!UserService.isLogin()) {
        return next({ path: '/' });
      }
      // 默认需要登录的页面旧需要绑定，notBind代表需要登录的页面但不需要绑定也可以进入
      if (!to.meta.notBind && to.name !== 'bind' && UserService.wxinfo && !UserService.wxinfo.openid && !UserService.is_palmyou) {
        return next({
          path: '/bind',
          query: { redirectUrl: encodeURIComponent(to.fullPath) },
        });
      }
    }

    // 需要管理员登录
    if (to.matched.some(path => path.meta.needAdmin)) {
      if (!UserService.isLogin()) {
        return next({ path: '/' });
      }

      if (UserService.is_admin === 0) {
        return next({
          path: '/',
        });
      }
    }

    // 如果跳到bind界面 需要将关注公众号弹窗关闭
    if (to.name === 'bind' && from.path === '/') {
      store.commit('followOA/SWITCH_MODAL_SHOW', { show: false });
    }

    // 进入特定页面时删除订单数据
    if (['index', 'countries', 'orders', 'products', 'product', 'account'].indexOf(to.name) > -1) {
      Object.keys(Order).forEach((k) => {
        delete Order[k];
      });
    }

    next();
  }, 0);
});

// 腾讯统计
router.afterEach(() => {
  if (window.MtaH5 && !env) {
    MtaH5.pgv();
  }
  if (!env) {
    Vue.nextTick(() => {
      sensorsdata.quick('autoTrackSinglePage');
    });
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router.js